module.exports = __webpack_public_path__ + "img/WhiskyMacallan12Anos.96197f73.jpg";